import React from "react";

import { Page } from "../layout/Page";

export const AdminPage = () => {
  return <Page></Page>;
};
